import { postRequest } from '@/config/network'
import login from './login'
import main from './main'
import { sysFirstEnjoy, advFirstEnjoy } from './sys-first-enjoy'
import sysMiniprogram from './sys-miniprogram'
import activity from './activity'
import member from './member'
import adv from './adv'
import operate from './operate'

const totalApiConfig = {
  operate,
  adv,
  sysMiniprogram,
  sysFirstEnjoy,
  advFirstEnjoy,
  main,
  login,
  member,
  activity
}

Object.values(totalApiConfig).forEach(apiConfig => {
  Object.values(apiConfig).forEach(arr => {
    const [url] = arr
    Object.setPrototypeOf(arr, {
      post: (data = {}) => postRequest(url, data)
    })
  })
})

export default totalApiConfig
